import { Button } from '@mui/material';
import { styled, useTheme } from '@mui/material/styles';
import { ButtonProps } from '@mui/material/Button';
import { Stack } from '@mui/system';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import FlashOnIcon from '@mui/icons-material/FlashOn';
import { useParams } from 'react-router-dom';

type StyledButtonProps = ButtonProps & { active?: string };

interface IActionTabsProps {
  activeTab: number;
  isDisabled: boolean;
  onClick: (id: number) => void;
}

const StyledButton = styled(Button)<StyledButtonProps>(({ active }) => ({
  fontFamily: 'Montserrat',
  fontWeight: 600,
  textTransform: 'none',
  cursor: 'pointer',
  fontSize: '14px',
  padding: '8px 16px',
  color: '#000',
  border: 'none',
  borderRadius: '0',
  backgroundColor: active ? '#f8f9fb' : '#fff',
  '&:hover': {
    backgroundColor: '#f8f9fb',
  },

  '& .MuiButton-startIcon': {
    '& .MuiSvgIcon-fontSizeMedium': {
      fontSize: '14px',
    },
  },
}));

const ActionTabs: React.FC<IActionTabsProps> = ({ onClick, activeTab, isDisabled }) => {
  const theme = useTheme();
  const { url } = useParams();

  return (
    <Stack direction={'row'} sx={{background: theme.custom.palette.primary.white}}>
      <StyledButton
        startIcon={<FlashOnIcon color={'primary'} />}
        onClick={() => onClick(1)}
        active={activeTab === 1 ? 'primary' : ''}
        disabled={isDisabled}
      >
        Результат
      </StyledButton>
      {url !== 'chat' && (
        <StyledButton
          startIcon={<AccessTimeIcon color={'primary'} />}
          onClick={() => onClick(2)}
          active={activeTab === 2 ? 'primary' : ''}
          disabled={isDisabled}
        >
          История
        </StyledButton>
      )}
    </Stack>
  );
};

export default ActionTabs;
